import { useMemo as e } from "react";
import { addDaysToDateString as t } from "@maat/datetime";
//#region src/components/DatePicker/hooks/useBlockedBounds.ts
function n(n, r, i, a, o, s, c) {
	return e(() => {
		if (n !== "end" || !r) return {
			effectiveMin: a,
			effectiveMax: o,
			impossibleRange: !1,
			nextBlockedFrom: void 0
		};
		let e, l, u;
		if (i?.length) {
			let n = i.filter((e) => e.from > r).sort((e, t) => e.from < t.from ? -1 : e.from > t.from ? 1 : 0), a = i.filter((e) => e.to < r).sort((e, t) => t.to < e.to ? -1 : t.to > e.to ? 1 : 0);
			l = n[0] ? n[0].from : void 0, u = l, e = a[0] ? t(a[0].to, 1) : void 0;
		}
		if (s && s > 0) {
			let n = t(r, s);
			e = e && e > n ? e : n;
		}
		if (c && c > 0) {
			let e = t(r, c);
			l = l && l < e ? l : e;
		}
		let d = e && a ? e > a ? e : a : e ?? a, f = l && o ? l < o ? l : o : l ?? o;
		return {
			effectiveMin: d,
			effectiveMax: f,
			impossibleRange: !!(d && f && d > f),
			nextBlockedFrom: u
		};
	}, [
		n,
		r,
		i,
		a,
		o,
		s,
		c
	]);
}
//#endregion
export { n as useBlockedBounds };
